import React, { useEffect, useRef } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AgentConversation } from './AgentConversation';
import { getApiUrl } from '../../utils/api';
import { useTenant } from '../../contexts/TenantContext';

/* LOT 11 · ?mission=manu.recrutement | clara.mois | sophie.catalogue démarre la conversation ; ?agent=<id> la rouvre, depuis n'importe quel module */
export const AgentHost = () => {
  const [params, setParams] = useSearchParams();
  const navigate = useNavigate();
  const { tenant } = useTenant();
  const enCours = useRef(false);
  const mission = params.get('mission');
  const conv = params.get('agent');
  useEffect(() => {
    if (!mission || !mission.includes('.') || enCours.current) return; // « pl_… » = mission de l'Accueil, pas une conversation
    enCours.current = true;
    const [a, s] = mission.split('.');
    axios.post(`${getApiUrl()}/agent-conv/mission/${a}/${s}`, {}, { withCredentials: true })
      .then((r) => { const p = new URLSearchParams(params); p.delete('mission'); p.set('agent', r.data.conv_id); setParams(p, { replace: true }); })
      .catch(() => { toast.error('L’agent n’a pas pu ouvrir la conversation. Réessayez.'); const p = new URLSearchParams(params); p.delete('mission'); setParams(p, { replace: true }); })
      .finally(() => { enCours.current = false; });
  }, [mission]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!conv) return null;
  const fermer = () => { const p = new URLSearchParams(params); p.delete('agent'); setParams(p); };
  return <AgentConversation convId={conv} agent="manu" onClose={fermer} onNav={(to) => { fermer(); navigate(`/${tenant?.slug}/${to}`); }} />;
};
